import React, { useEffect, useState } from 'react';
import ListView from './ListView.js';
import DetailView from './DetailView.js';
import axios from 'axios';

export default function AppWrapper() {
  const [fetchedUTMList, updateUTMList] = useState([]); // UTM batch fetched from db
  const [curBatch, setBatch] = useState({}); // Once a batch is selected for editing changes view
  const [user, setUser] = useState({});
  const [loading, setLoading] = useState(true);
  const [configs, setConfigs] = useState({}); // fetched configs for select dropdowns

  //track offset for lazy loading
  const [offset, setOffset] = useState(0);
  //instead of refreshing the whole page, handle lazing loading through a manual trigger
  const [loadMoreLabel, setLoadMoreLabel] = useState('Load More');
  //handle isolated archived data
  const [archivedBatchList, setArchivedBatchList] = useState([]);

  const isEmpty = (obj) => Object.keys(obj).length === 0;

  const curView = isEmpty(curBatch) ? (
    <ListView setBatch={setBatch} batchList={fetchedUTMList} curUser={user} archivedBatchList={archivedBatchList} updateUTMList={updateUTMList} setArchivedBatchList={setArchivedBatchList}/>
  ) : (
    <DetailView changeView={setBatch} curBatch={curBatch} configs={configs} setOffset={setOffset}/>
  );

  // Sorts UTM Batch by Timestamp
  const sortByRecent = (utmData) => {
    const options = {
      weekday: 'long',
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    };
    let utmArray = [utmData];

    utmArray = utmArray.map((i) => {
      const values = Object.values(i);
      values.sort((a, b) => a.date - b.date);
      values.reverse();

      // Format Date for List View
      values.forEach((i) => {
        let newDate = new Date();
        newDate.setTime(i.date * 1000);
        const dateString = newDate.toLocaleDateString(undefined, options);
        const timeString = newDate.toLocaleTimeString('en-US', {
          hour: '2-digit',
          minute: '2-digit',
          timeZone: 'UTC'
        });
        const formattedTime = dateString + ' ' + timeString;
        i.date = formattedTime;
      });
      return values;
    });

    return utmArray;
  };

  const fetchData = async (loadMore = false) => {
    await axios
      .get('/wp-admin/admin-ajax.php?action=get_utm_codes_for_user', {
        params: {
          offset: offset, // attach current offset
          posts_per_page: 50 // number of posts to fetch per request
        }
      })
      .then((res) => {
        const newUTMs = sortByRecent(res.data.data.utms);
        setArchivedBatchList(sortByRecent(res.data.data.archivedUTMs));

        if (loadMore) {
          // if loadMore, append the new data to the existing list
          updateUTMList((prev) => [...prev, ...newUTMs]);
        } else {
          // If it's the initial load, just set the new UTM list
          updateUTMList(newUTMs);
        }
        // increment offset for next load request
        setOffset((prevOffset) => prevOffset + 50);
        //set user id
        setUser(res.data.data.userID);
      })
      //show that crazy table
      .finally(() => setLoading(false));
  };

  // Call fetchData with load more option
  const loadMoreUTMs = async () => {
    setLoadMoreLabel('Loading More UTMs...');
    await fetchData(true); // Set loadMore to true
    setLoadMoreLabel('Load More');
  };

    // Format and Populate Configs for Select Options
   //rehomed this from DetailView to the appWrapper, goal is to only make this call once since these values should change from item to item and pass in the configs to the detail view to avoid duplicate calls
   const fetchConfigs = async () => {
    const sources = await axios
      .get('/wp-admin/admin-ajax.php?action=get_utm_sources')
      .then((res) => {
        return res.data.data.sources;
      });
    const mediums = await axios
      .get('/wp-admin/admin-ajax.php?action=get_utm_mediums')
      .then((res) => {
        return res.data.data.mediums;
      });
    const campaigns = await axios
      .get('/wp-admin/admin-ajax.php?action=get_utm_campaigns')
      .then((res) => {
        return res.data.data.campaigns;
      });

    let campaignOptions = [];
    for (const [key, value] of Object.entries(campaigns)) {
      const keyName = `${value.name}+${value.utm_campaign_audience.label}+${value.utm_campaign_strategy.label}`;
      const item = { [keyName]: key };
      campaignOptions.push(item);
    }

    // Alpha Sort Array of Single Key Objects
    campaignOptions.sort((a, b) => {
      const firstItem = Object.keys(a).map((key) => key);
      const secondItem = Object.keys(b).map((key) => key);

      if (firstItem > secondItem) {
        return 1;
      }
      if (secondItem > firstItem) {
        return -1;
      }
      return 0;
    });

    campaignOptions.unshift('Please Choose');

    let sourceOptions = [];
    for (const [key, value] of Object.entries(sources)) {
      const item = { [value]: key };
      sourceOptions.push(item);
    }
    sourceOptions.unshift('Please Choose');

    let mediumOptions = [];
    for (const [key, value] of Object.entries(mediums)) {
      const item = { [value]: key };
      mediumOptions.push(item);
    }
    mediumOptions.unshift('Please Choose');

    const selectConfigs = {
      campaign: {
        label: 'campaign',
        options: campaignOptions
      },
      medium: {
        label: 'medium',
        options: mediumOptions
      },
      source: {
        label: 'source',
        options: sourceOptions
      }
    };
    setConfigs(selectConfigs);
  };

//handle the correct calls for UTM data in one useEffect. previously these calls were being made everytime the page was switching between list and detail view causing 10 sec loads
//fetchConfigs should only be called once on initial load
//fetchData should be hit everytime the user goes to listview
useEffect(() => {
  const fetchResources = async () => {
    if (isEmpty(curBatch)) {
      if (loading) {
        await fetchConfigs();
      }
      await fetchData();
    }
  };
  fetchResources();
}, [curBatch]);


  return (
    <div>
      <div className="utm utm__app-wrapper">
        {loading ? (
          <div className="container u--margin-top-35">
            <div>Loading...</div>
          </div>
        ) : (
          <div>
            <div>{curView}</div>

            {/* if curBatch is empty that means its list view so give the people their load more btn */}
            {isEmpty(curBatch) && 
              <div className="container">
                <div className="grid grid--between">
                  <button
                    className="btn btn--blue u--margin-left-10"
                    onClick={loadMoreUTMs}
                    style={{padding: "30px"}}
                  >
                  <span className="btn__content">
                    <span className="btn__text">{loadMoreLabel}</span>
                  </span>
                </button>
                </div>
              </div>
            }
          </div>
        )}
      </div>
    </div>
  );
}
